import AnyChart from 'anychart-react';
import React from 'react';
import {mapExposureColor} from "../utils";
import { chartBaseJsonConfig, scatterConfigJson } from '../../../../../charts/configJson';


const ExposureBubbleChart = ({ maxExposureData, currentWeights }) => {
  const scatterData = maxExposureData.map(item => ({
    x: currentWeights[item.x.toLowerCase()] * 100, // assuming currentWeights are fractions
    value: parseFloat(item.value),
    name: item.x,
    fill: mapExposureColor(item.value),
    stroke: mapExposureColor(item.value),
    markerSize: 15

  }));

  let scatterChartSettings = {
    type: 'scatter',
    data: scatterData,
    yAxis: {
      title: 'Max Exposure (%)',
    },
    xAxis: {
      title: 'Current Exposure (%)'
    },
    height: '600px',
    ...scatterConfigJson.apply()
    // Configure other chart settings as needed
  };
  scatterChartSettings = chartBaseJsonConfig.applyBaseConfig(scatterChartSettings);
  return <AnyChart id={'scatter-chart-exposure-chart'} {...scatterChartSettings} />;
};

export default ExposureBubbleChart;